import React, { useState, useMemo } from 'react';
import { Select, Input, FormInstance, Checkbox } from 'antd';
import FormBuilder from 'vcomponents/FormBuilder/index2';
import { NaverAddressSearchModal } from 'vcomponents/AddressPost/NaverAddressPost';

import { QUICK_ADDRESS_COLUMN, SAVE_ADDRESS_COLOUMN } from '../viewMeta';
import { AddressFormWrapper } from '../styles';

const { Search: SearchInput } = Input;

interface AddressFormProps {
  context: any;
  type: string;
  addressBookList: any[];
  selectedAddress: any;
  // eslint-disable-next-line no-unused-vars
  onChange: any;
}

const NaverAddressForm = ({ context, type, addressBookList, selectedAddress, onChange }: AddressFormProps) => {
  const [form, setForm] = useState<FormInstance>();
  const [isSave, setIsSave] = useState<boolean>(true);

  const addressBooks = useMemo(() => {
    const array = addressBookList?.map(({ addressBookIdx, addressBookName }) => ({
      value: addressBookIdx,
      label: addressBookName
    }));
    return [{ value: 0, label: '새로운 주소 입력' }].concat(array || []);
  }, [addressBookList]);

  const coloumns = useMemo(() => {
    return isSave ? QUICK_ADDRESS_COLUMN.concat(SAVE_ADDRESS_COLOUMN) : QUICK_ADDRESS_COLUMN;
  }, [isSave]);

  const handleAddressModal = () => context.showModal(`naver-${type}-address-search`);

  const handleAddressChange = (key: any, value: any, address: any) => {
    if (key && typeof value !== 'undefined') {
      const targetValue = value?.target ? value?.target?.value : value;
      onChange((prev) => ({ ...prev, [key]: targetValue }));
    } else {
      onChange((prev) => ({ ...prev, ...address }));
    }
  };

  const handleAddressBookChange = (addressBookIdx: number) => {
    const address = addressBookList?.find((item) => item.addressBookIdx === addressBookIdx);
    if (!address) {
      onChange(undefined);
      form.resetFields();
      setIsSave(true);
    } else if (!address?.gpslat || !address?.gpslon) {
      // @ts-ignore
      window.naver.maps.Service.geocode(
        { query: address?.roadAddress || address?.jibunAddress },
        (state: number, response: any) => {
          // @ts-ignore
          if (state === window.naver.maps.Service.Status.OK) {
            const result = response.v2.addresses[0];
            setIsSave(false);
            onChange((prevState) => ({
              ...prevState,
              ...address,
              gpslat: result.y,
              gpslon: result.x,
              isSaveAddress: false
            }));
          }
        }
      );
    } else {
      setIsSave(false);
      onChange((prevState) => ({ ...prevState, ...address, isSaveAddress: false }));
    }
  };

  return (
    <AddressFormWrapper>
      <div style={{ padding: '0px 0px 10px 12px', fontWeight: 700, color: '#0BB656' }}>
        {type === 'pickup' ? '보내는 분' : '받는 분'}
      </div>
      <FormBuilder
        columns={coloumns}
        data={selectedAddress}
        onValuesChange={handleAddressChange}
        setForm={(f: any) => {
          setForm(f);
          return {};
        }}
      >
        <div id="addressBooks">
          <Select defaultValue={0} options={addressBooks} onChange={handleAddressBookChange} />
        </div>
        <div id="addressSearchButton">
          <SearchInput
            readOnly
            value={selectedAddress?.roadAddress || selectedAddress?.jibunAddress}
            placeholder="주소를 입력해 주세요"
            onClick={handleAddressModal}
            onSearch={handleAddressModal}
          />
        </div>
        <div id="isSaveAddress">
          <Checkbox onChange={({ target }) => handleAddressChange('isSaveAddress', target.checked, null)}>
            입력한 주소를 주소록에 등록하겠습니다.
          </Checkbox>
        </div>
      </FormBuilder>
      <NaverAddressSearchModal
        id={`naver-${type}-address-search`}
        onChange={(address) => handleAddressChange(null, null, address)}
      />
    </AddressFormWrapper>
  );
};

export default NaverAddressForm;
